<template>
	<div>
		<div class="ft20 cl-black cl-main ftw500">角色管理</div>
		
		<div class="mt20">
			<div class="bg-w pd30" style="min-height: 800px;">
				<div>
					<a-button type="primary" icon="plus" @click="addAct()">添加角色</a-button>
				</div>
				
				<div class="mt30">
					<div class="wxb-table-white">
						<a-table rowKey="role_id" :columns="columns" :pagination="pagination" @change="handleTableChange" :data-source="datas"
						 :loading="loading">
							
							<!-- <div class="text-center" slot="type" slot-scope="type,record">
								{{ getTypeLabel(type) }}
							</div> -->
							
							<template slot="action" slot-scope="record,index">
								<div class="flex center">
									<a-dropdown placement="bottomRight">
										<span class="more-act">
											<i class="iconfont iconmore_gray"></i>
										</span>
										<a-menu slot="overlay">
											  <a-menu-item>
												<a class="menu-act" href="javascript:;" @click="editAct(record)">
													<i class="iconfont ft14 iconedit"></i>
													<span class="ml10">编辑</span>
												</a>
											  </a-menu-item>
											  <a-menu-item>
												<a class="menu-act" href="javascript:;" @click="del(record)">
													<i class="iconfont ft14 icondelete"></i>
													<span class="ml10">删除</span>
												</a>
											  </a-menu-item>
										</a-menu>
									  </a-dropdown>
								</div>
							</template>
						</a-table>
					</div>
				</div>
			</div>
		</div>
	
		<div v-if="editVisible">
			<edit-sysrole :role_id="role_id" :visible="editVisible" @cancel="cancelEditAct" @ok="okEditAct"></edit-sysrole>
		</div>
	</div>
</template>

<script>
	import {
		listMixin
	} from '../../common/mixin/list.js';
	import editSysrole from './components/sysrole/modal/editSysrole.vue';
	export default {
		components:{
			editSysrole,
		},
		mixins: [listMixin],
		data() {
			return {
				loading: false,
				editVisible:false,
				role_id:0,
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				columns: [
					
					{title: '角色名称',dataIndex: 'name',align: 'center'},
					{title: '角色ID',dataIndex: 'role_id',align: 'center'},
					{title: '角色描述',dataIndex: 'desc',align: 'center'},
					{title: '创建时间',dataIndex: 'add_time_format',align: 'center',ellipsis: true},
					{title: '排序',dataIndex: 'sort',align: 'center',ellipsis: true},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}}
				],
				datas: [],
				/*types: [
					{
						value: 'M',
						label: '目录'
					},
					{
						value: 'C',
						label: '菜单'
					},
					{
						value: 'A',
						label: '按钮'
					}
				]*/
			}
		},
		methods: {
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getSysroleList',{
					limit:this.pagination.pageSize,
					page:this.pagination.current,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			
			addAct(){
				this.role_id = 0;
				this.editVisible=true;
			},
			editAct(record){
				// console.log('edit',record)
				this.role_id = record.role_id;
				this.editVisible=true;
			},
			cancelEditAct(){
				this.editVisible=false;
			},
			okEditAct(){
				this.editVisible=false;
				this.getLists();
			},
			
			del(record){
				this.$confirm({
					title:'确认删除吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/delSysrole',{
								role_id:record.role_id,
							}).then(res=>{
								this.$message.success('删除成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
			// 根据 type 值获取对应的中文标签
			getTypeLabel(type) {
				if (!type) return '-';
				const found = this.types.find(item => item.value === type);
				return found ? found.label : '未知类型';
			},
		}
	}
</script>

<style>
	.goods-type-icon img{
		width: 60px;
		height: 60px;
	}
</style>